export const LOGIN = 'LOGIN';
export const SSO_LOGIN = 'SSO_LOGIN';
